import {z} from "zod";

export const referenceDataLocale = z.string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/);

export const localizedReferenceDataResponse = z.object({
    id: z.string().uuid(),
    active: z.boolean(),
    alias: z.string(),
    name: z.string(),
    label: z.string().nullable(),
    parent_id: z.string().uuid().nullable(),
});

export type LocalizedReferenceDataResponse = z.infer<typeof localizedReferenceDataResponse>;

export const referenceDataTranslationResponse = z.object({
    locale: referenceDataLocale,
    name: z.string(),
    label: z.string().nullable(),
});

export const referenceDataEntityResponse = z.object({
    id: z.string().uuid(),
    active: z.boolean(),
    alias: z.string(),
    translations: z.array(referenceDataTranslationResponse),
});

export type ReferenceDataEntityResponse = z.infer<typeof referenceDataEntityResponse>;

export const referenceDataLocalizationRequest = z.object({
    language: referenceDataLocale,
    fallbackLanguage: referenceDataLocale,
});
